import { FC } from "react";

import {
  BASE_CHIP_CLASSNAME,
  PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_HIDE,
  PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_SHOW,
  RED_CHIP_CLASSNAME,
} from "./interaction-mode/helpers";

import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { Tooltip } from "mds/components/Tooltip";
import { LockLockedIcon } from "mds/icons";

export const PageLockedChip: FC<{ canAuthorSection: boolean }> = ({ canAuthorSection }) => {
  const tooltipText = canAuthorSection
    ? t("lock_status.page_locked_help")
    : t("lock_status.student_lock_warning");
  return (
    <Tooltip text={tooltipText}>
      <IconText
        className={`${BASE_CHIP_CLASSNAME} ${RED_CHIP_CLASSNAME}`}
        containerQueryClassNameHide={PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_HIDE}
        containerQueryClassNameShow={PAGE_METADATA_CONTAINER_QUERY_CLASS_NAME_SHOW}
        iconStart={<LockLockedIcon size="xs" />}
        text={t("lock_status.locked")}
      />
    </Tooltip>
  );
};
